/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};





$(document).ready(function() {
    $('.load-more__button').on('click', function(event) {
      event.preventDefault();

      var nextPageUrl = $(this).data('next-page');

      if (nextPageUrl) {
        $.ajax({
          url: nextPageUrl,
          method: 'GET',
          dataType: 'html',
          success: function(data) {
            var products = $(data).find('.product-list--collection').html();
            var pagination = $(data).find('.pagination').html();

            $('.product-list--collection').append(products);
            $('.pagination').html(pagination);

            var nextUrl = $(data).find('.pagination__next').attr('href');
            $('.load-more__button').data('next-page', nextUrl);

            // If no more pages, hide the "Load More" button
            if (!nextUrl) {
              $('.load-more').hide();
            }
          },
          error: function(xhr, status, error) {
            console.error('Error fetching products:', error);
          }
        });
      }
    });
  });




/* --- Open cart drawer after Add to Cart (DESKTOP ONLY) --- */
(function () {
  // Dawn + many Shopify themes use 990px as the desktop breakpoint.
  // If your theme uses something else, change the query below.
  var DESKTOP_QUERY = '(min-width: 990px)';
  var mql = window.matchMedia(DESKTOP_QUERY);
  var isDesktop = function () { return mql.matches; };

  function openMiniCart() {
    if (!isDesktop()) return; // only on desktop

    var toggle =
      document.querySelector('[data-action^="toggle-mini-cart"]') ||
      document.querySelector('.header__cart-toggle') ||
      document.querySelector('[aria-controls="mini-cart"]');

    if (toggle) {
      if (toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
    } else {
      // last-resort fallback
      window.location.assign('/cart');
    }
  }

  // If the theme announces adds/refreshes, open the drawer (desktop only)
  document.documentElement.addEventListener('product:added', function(){ if (isDesktop()) openMiniCart(); });
  document.documentElement.addEventListener('cart:refresh', function(){ if (isDesktop()) openMiniCart(); });

  // Force AJAX add-to-cart ONLY on desktop; mobile uses default behavior
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (
        form.matches('form.product-form') ||
        form.matches('form[action^="/cart/add"]')
      ) {
        if (!isDesktop()) return; // let mobile behave as-is

        e.preventDefault();

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
          credentials: 'same-origin'
        })
          .then(function (r) {
            if (!r.ok) throw new Error('Add failed');
            return r.json();
          })
          .then(function () {
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:refresh', { bubbles: true })
            );
            openMiniCart();
          })
          .catch(function () {
            // if anything breaks, fall back to normal submission
            form.submit();
          });
      }
    },
    true
  );
})();



// Put this in assets/custom.js (after jQuery is loaded)
(function ($) {
  // target only the Letters field by its name
  const selector = 'input[name="properties[alphabets]"]';

  // Block non-letters on keypress (nice UX)
  $(document).on('keypress', selector, function (e) {
    const k = e.which;
    // allow control keys: backspace, tab, enter, arrows
    if (k === 8 || k === 9 || k === 13 || k === 37 || k === 39) return;
    const ch = String.fromCharCode(k);
    if (!/[A-Za-z\s]/.test(ch)) e.preventDefault();
  });

  // Clean up pasted/auto-filled text (also catches IME & edge cases)
  $(document).on('input', selector, function () {
    this.value = this.value.replace(/[^A-Za-z\s]/g, '');
  });
})(jQuery);


// document.addEventListener('DOMContentLoaded', () => {
//   const swatches = document.querySelectorAll('.cstm_variants .swatch-label');
//   const priceEl = document.querySelector('.price-list .price-regular');

//   if (!priceEl || !swatches.length) return;

//   swatches.forEach((swatch) => {
//     swatch.addEventListener('click', () => {
//       const newPrice = swatch.getAttribute('data-price');
//       if (newPrice) {
//         priceEl.textContent = newPrice;
//       }

//       // Optional: visually mark selected swatch
//       swatches.forEach(s => s.classList.remove('active'));
//       swatch.classList.add('active');
//     });
//   });
// });



document.addEventListener('DOMContentLoaded', () => {
  const swatches = document.querySelectorAll('.cstm_variants .swatch-label');
  const priceRegularEl = document.querySelector('.price-list .price-regular');

  if (!swatches.length) return;

  swatches.forEach((swatch) => {
    const form = swatch.closest('form[action="/cart/add"]');
    if (!form) return;
    const tooltipTextEl = form.querySelector('.swatch-tooltip-text'); // tooltip inside this form
    //const priceRegularEl = form.querySelector('.price-regular');
    swatch.addEventListener('click', () => {
      const price = swatch.getAttribute('data-price') || "";
      const comparePrice = swatch.getAttribute('data-compare-price') || "";
      const tooltipText = swatch.getAttribute('data-tooltip') || "";
      const freePersonalizedCard = swatch.getAttribute('data-free-personalized-card') === "true";

      // Update prices (Regular and showing the Compare Pricing)
    
      if (comparePrice != "") {
        priceRegularEl.innerHTML = `
          <span class="price-compare"><s>${comparePrice}</s></span>
          <span class="price-sale with-sale-badge">${price}</span>
        `;
      } else {
        priceRegularEl.textContent = price;
      }
      

      // Update tooltip text for this form only
      if (tooltipTextEl) tooltipTextEl.textContent = tooltipText;

      // Mark active swatch in this form only
      swatches.forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');

      // Handle hidden input for this form
      let input = form.querySelector('input[name="properties[Ballons Details]"]');
      if (tooltipText.trim() !== "") {
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = "properties[Ballons Details]";
          form.appendChild(input);
        }
        input.value = tooltipText;
        console.log("Tooltip added:", tooltipText);
      } else if (input) {
        input.value = "";
        console.log("Tooltip cleared");
      }

      // Store metafield info for personalized card
      form.dataset.freePersonalizedCard = freePersonalizedCard ? "true" : "false";

      // OOS Product CHECK
      const isAvailable = swatch.getAttribute('data-variant-available') === 'true';
      

      // Select both buttons inside the same form
      const buttons = form.querySelectorAll(
        '.product-form__add-button, .mobile-add-to-cart-btn'
      );

      buttons.forEach((btn) => {
        if (!btn) return;

        // Find text node (keep icons/spans intact)
        let textNode = [...btn.childNodes].find(
          node => node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== ''
        );

        if (!textNode) {
          textNode = document.createTextNode(' Add to cart');
          btn.appendChild(textNode);
        }

        if (!isAvailable) {
          btn.disabled = true;
          btn.classList.add('sold-out', 'button--disabled');
          textNode.textContent = ' Sold Out';
        } else {
          btn.disabled = false;
          btn.classList.remove('sold-out', 'button--disabled');
          textNode.textContent = ' Add to cart';
        }
      });
      
    });
  });

  // Add to Cart button click
  document.querySelectorAll('form[action="/cart/add"] [type="submit"]').forEach(button => {
    button.addEventListener('click', (event) => {
      const form = button.closest('form[action="/cart/add"]');
      if (!form) return;

      const input = form.querySelector('input[name="properties[Ballons Details]"]');
      if (input) console.log("Submitting with tooltip:", input.value);

      // Redirect if product has free personalized card
      if (form.dataset.freePersonalizedCard === "true") {
        setTimeout(() => {
          // Dynamically read metafield product URL if available
          const url = form.dataset.freePersonalizedUrl || "/a/greeting-cards/";
          window.location.href = url;
        }, 750);
      }
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-tooltip]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.stopPropagation(); // Prevent click from bubbling
      el.classList.toggle('active'); // Show tooltip on click

      // Optional: hide tooltip after 3 seconds
      setTimeout(() => {
        el.classList.remove('active');
      }, 3000);
    });
  });

  // Hide tooltip if clicking outside
  document.addEventListener('click', () => {
    document.querySelectorAll('[data-tooltip].active').forEach(el => {
      el.classList.remove('active');
    });
  });
});



document.addEventListener('DOMContentLoaded', function () {
  const productLists = document.querySelectorAll('.product-list.product-list--collection');
  if (!productLists.length) return;

  function fixGreetingCard(productList) {
    const cards = productList.querySelectorAll('.product-greeting-card');
    if (!cards.length) return;

    // Remove all but the last greeting card
    cards.forEach((card, index) => {
      if (index !== cards.length - 1) {
        card.remove();
      }
    });

    // Ensure greeting card is LAST
    const lastCard = cards[cards.length - 1];
    if (lastCard !== productList.lastElementChild) {
      productList.appendChild(lastCard);
    }
  }

  productLists.forEach((productList) => {
    // Initial fix
    fixGreetingCard(productList);

    // Observe AJAX appends
    const observer = new MutationObserver(() => {
      fixGreetingCard(productList);
    });

    observer.observe(productList, { childList: true });
  });
});
